<template>
    <div class="profile-sidebar">

        <div class="profile-sidebar__top">
            <div class="profile-sidebar__image">
                <img :src="user.profileImageUrl" v-if="user.profileImageUrl" />
            </div>
            <h1 class="profile-sidebar__name h2">{{user.name}}</h1>
            <div class="profile-sidebar__info text text--large">
                <span v-if="user.totalScore"><strong>{{user.totalScore}}</strong> <translate>trac_score</translate></span>
                <span v-if="user.location"> |  {{user.location}}</span>
            </div>
            <div class="profile-sidebar__followers">
                <div class="profile-sidebar__followers__item text text--large">
                    <strong>{{user.followingCount}}</strong> <translate>following</translate>
                </div>
                <div class="profile-sidebar__followers__item text text--large">
                    <strong>{{user.followersCount}}</strong> <translate>followers</translate>
                </div>
            </div>
        </div>

        <div class="profile-sidebar__links">
            <router-link :to="{name: 'Profile'}">
                <div class="profile-sidebar__link h6" v-translate>activities</div>
            </router-link>
            <router-link :to="{name: 'Account'}">
                <div class="profile-sidebar__link h6" v-translate>account</div>
            </router-link>
            <router-link :to="{name: 'FitnessSettings'}">
                <div class="profile-sidebar__link h6" v-translate>fitness_settings</div>
            </router-link>
             <router-link :to="{name: 'DeleteAccount'}">
                <div class="profile-sidebar__link h6" v-translate>delete_account</div>
            </router-link>
        </div>

        <div class="profile-sidebar__logout">
            <puma-button @click="logout"><translate>log_out</translate></puma-button>
        </div>

    </div>
</template>

<script>
import { mapGetters } from "vuex"
import { clearUser } from '../utils/authentication';
import router from "../router";
import {addTrackingObject} from "@/utils/tracking"

export default {
    name: 'ProfileSidebar',
    computed: {
        ...mapGetters(['user']),
    },
    methods: {
        logout() {
            clearUser();
            addTrackingObject({subSection: "profile", screenName: "profile"}, {type: "logout", value: "web_userprofile_logout"});

            if(window.location.pathname == '/'){
                this.$forceUpdate(); 
            } else {
                router.push({name: 'Discover'});
            }
        },
    }

}
</script>

<style lang="scss" scoped>
.profile-sidebar {
    @include mq($until: tablet-landscape) {
        display: flex;
        flex-direction: column;
    }

    &__top {
        order: 1;
        padding: 70px 40px 40px;

        @include mq($until: desktop) {
            padding: 60px 30px 40px;
        }

        @include mq($until: tablet-landscape) {
            padding: 30px $page-padding-small 30px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: center;
        }

        @include mq(tablet-landscape, $and: '(max-height: 900px)') {
            padding-top: 30px;
        }
    }

    &__image {
        position: relative;
        background: black;
        width: 142px;
        height: 142px;
        border-radius: 100%;
        overflow: hidden;
        margin-bottom: 30px;

        @include mq($until: mobile-landscape) {
            width: 122px;
            height: 122px;
            margin-bottom: 20px;
        }

        @include mq(tablet-landscape, $and: '(max-height: 900px)') {
            margin-bottom: 20px;
            width: 122px;
            height: 122px;
        }

        img {
            @include object-fit;
            border-radius: 100%;
        }
    }

    &__info {
        margin-top: 10px;
    }

    &__followers {
        display: flex;
        width: 100%;
        margin-top: 32px;
        max-width: 340px;

        &__item {
            width: 100%;
            padding: 16px 10px 18px;
            background: rgba(black, 0.1);
            text-align: center;

            &:not(:last-child) {
                border-right: 1px solid rgba(black, 0.1);
            }
        }
    }

    &__links {
        @include mq($until: tablet-landscape) {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            order: 3;
        }
    }

    &__link {
        padding: 30px 40px;
        text-transform: uppercase;
        height: 100%;
        display: flex;
        align-items: center;

        @include mq($until: tablet-landscape) {
            padding: 15px 20px;
            text-align: center;
            justify-content: center;
        }

        @include mq($until: tablet) {
            font-size: $puma-size-font-sm;
        }

        @include mq($until: mobile-landscape) {
            padding: 10px 15px;
            font-size: $puma-size-font-xs;
        }

        @include mq(tablet-landscape, $and: '(max-height: 900px)') {
            padding-top: 20px;
            padding-bottom: 20px;
        }

        .router-link-exact-active & {
            background: white;
            border-left: 6px solid black;
            padding-left: 34px;

            @include mq($until: tablet-landscape) {
                border-left: none;
                border-top: 3px solid black;
                padding-left: 20px;
                padding-top: 12px;
            }

            @include mq($until: mobile-landscape) {
                padding-left: 15px;
                padding-top: 7px;
            }
        }
    }

    &__logout {
        margin-top: 40px;
        padding: 0 40px 40px;

        @include mq($until: desktop) {
            padding: 0 30px 40px;
        }

        @include mq($until: tablet-landscape) {
            order: 2;
            margin-top: 0;
            padding: 0 $page-padding-small 40px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: center;
        }
    }
}
</style>